import React from "react";
import { Control } from "react-hook-form";
import { ConnectedEntity } from "src/types/apps";

import CredentialsCheckbox from "./components/CredentialsCheckbox";
import DConnectButton from "./components/DConnectBtn/DConnectButton";
import DErrorResult from "./components/DErrorResult";
import FixedInputs from "./components/FixedInputs";
import MessageEntityAlert from "./components/MessageEntityAlert";
import RowSelector from "./components/RowSelector/RowSelector";
import SuccessResult from "./components/SuccessResult";
import ConfirmationTimer from "./ConfirmationTimer";

interface FormComponentsProps {
	errorMessage?: string;
	isSuccess?: boolean;
	showSelector?: boolean;
	entity?: ConnectedEntity;
	totpNeeded?: boolean;
	userConfirmationNeeded?: boolean;
	selectedValue: string;
	onChangeSelect: (value: string) => void;
	showSaveCheckbox?: boolean;
	isLoading?: boolean;
	control: Control<{}, any>;
}

const DynamicForm: React.FC<FormComponentsProps> = ({
	errorMessage,
	isSuccess,
	showSelector,
	entity,
	totpNeeded,
	userConfirmationNeeded,
	selectedValue,
	onChangeSelect,
	showSaveCheckbox,
	isLoading,
	control
}) => {
	return (
		<>
			<MessageEntityAlert />
			{errorMessage && <DErrorResult errorMessage={errorMessage} />}
			{isSuccess && <SuccessResult />}
			{showSelector && !entity?.maintenance && (
				<RowSelector onChangeSelect={onChangeSelect} selectedValue={selectedValue} />
			)}
			{!isSuccess && !entity?.maintenance && (
				<FixedInputs
					userConfirmationNeeded={userConfirmationNeeded}
					totpNeeded={totpNeeded}
					control={control}
				/>
			)}

			{(userConfirmationNeeded || totpNeeded) && !isSuccess && (
				<ConfirmationTimer isTotp={totpNeeded} />
			)}

			{!totpNeeded && showSaveCheckbox && !isSuccess && !userConfirmationNeeded && (
				<CredentialsCheckbox />
			)}
			{!isSuccess && (
				<DConnectButton loading={isLoading} userConfirmationNeeded={userConfirmationNeeded} />
			)}
		</>
	);
};

export default DynamicForm;
